/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: actions.ts
 * Class: actions.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { ActionTree } from 'vuex';
import axios, { AxiosResponse } from 'axios';
import { PriceRequest, PriceResponse, PriceState } from './types';
import { RootState } from '../types';
import { ApiEndpointEnum, getApiRequestConfig } from '../../config/network';

export const actions: ActionTree<PriceState, RootState> = {
  fetchPrice({ commit }, payload: PriceRequest): void {
    commit('priceLoading');

    let url = `orderPrice?productKey=${payload.productKey}&locationKey=${payload.locationKey}&durationDays=${payload.duration}&units=${payload.units}`;

    if (payload.extras) {
      payload.extras.forEach((selectedExtension) => {
        url += `&extras[${selectedExtension.key}]=${selectedExtension.value}`;
      });
    }

    this.state.$http(
      url,
      getApiRequestConfig(ApiEndpointEnum.ProductAPI),
    )
      .then((response: AxiosResponse<PriceResponse>) => {
        const price: PriceResponse = response && response.data;
        commit('priceLoaded', price);
      }, (error) => {
        commit('priceFailure');
      }).catch(() => {
        commit('priceFailure');
      });
  },
};
